import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from '@angular/core';
import { HandleDates } from '@app/common/services/handle-dates.service';
import { PlexEnvironment } from '@app/env';
import { IConstructionTypeDto } from '@app/shared/models/dtos/construction-type';
import { ICostCodeCostTypeDto } from "@app/shared/models/dtos/cost-code-cost-type";
import { IEquationDto } from "@app/shared/models/dtos/equation";
import { IFunctionDto } from '@app/shared/models/dtos/function';
import { IProjectSubTypeDto } from "@app/shared/models/dtos/project-subtype";
import { IProjectTypeDto } from "@app/shared/models/dtos/project-type";
import { IProjectTypePhasesAndStepsDto } from "@app/shared/models/dtos/project-type-phases-and-steps";
import { IUnitOfMeasureDto } from "@app/shared/models/dtos/unit-of-measure";

@Injectable({
  providedIn: 'root'
})
export class LookupService {
  private http = inject(HttpClient);
  private handleDates = inject(HandleDates);
  public environment = inject(PlexEnvironment);

  private BASE_URL = '';

  constructor() {
    this.BASE_URL = this.environment.apiUrl;
  }

  public async findCostCodeCostTypeDtos(): Promise<CostCodeCostTypeDtoResponse> {
    let url = `${this.BASE_URL}costcodecosttype/findcostcodecosttypes`;
    return this.http.get<CostCodeCostTypeDtoResponse>(url).toPromise().then(x => this.handleDates.handleDates(x));
  }

  public findProjectTypeDtos(): Promise<ProjectTypeDtoResponse> {
    let url = `${this.BASE_URL}lookup/findprojecttypes`;
    return this.http.get<ProjectTypeDtoResponse>(url).toPromise().then(x => this.handleDates.handleDates(x));
  }

  public async findFunctionDtos(): Promise<FunctionDtoResponse> {
    let url = `${this.BASE_URL}lookup/findFunctions`;
    return this.http.get<FunctionDtoResponse>(url).toPromise().then(x => this.handleDates.handleDates(x));
  }

  public async findActiveFunctionDtos(): Promise<FunctionDtoResponse> {
    let url = `${this.BASE_URL}lookup/findActiveFunctions`;
    return this.http.get<FunctionDtoResponse>(url).toPromise().then(x => this.handleDates.handleDates(x));
  }

  public async findProjectSubTypeDtos(): Promise<ProjectSubTypeDtoResponse> {
    let url = `${this.BASE_URL}lookup/findprojectsubtypes`;
    return this.http.get<ProjectSubTypeDtoResponse>(url).toPromise().then(x => this.handleDates.handleDates(x));
  }

  public async findProjectActiveSubTypeDtos(): Promise<ProjectSubTypeDtoResponse> {
    let url = `${this.BASE_URL}lookup/findprojectsubtypes?isActive=true`;
    return this.http.get<ProjectSubTypeDtoResponse>(url).toPromise().then(x => this.handleDates.handleDates(x));
  }

  public async findConstructionTypeDtos(): Promise<ConstructionTypeDtoResponse> {
    let url = `${this.BASE_URL}lookup/findconstructiontypes`;
    return this.http.get<ConstructionTypeDtoResponse>(url).toPromise().then(x => this.handleDates.handleDates(x));
  }

  public async findUnitOfMeasureDtos(): Promise<UnitOfMeasureDtoResponse> {
    let url = `${this.BASE_URL}lookup/findunitofmeasures`;
    return this.http.get<UnitOfMeasureDtoResponse>(url).toPromise().then(x => this.handleDates.handleDates(x));
  }

  public async findProjectTypePhasesAndStepsDto(): Promise<ProjectTypePhasesAndStepsDtoResponse> {
    let url = `${this.BASE_URL}lookup/findprojecttypephasesandsteps`;
    return this.http.get<ProjectTypePhasesAndStepsDtoResponse>(url).toPromise().then(x => this.handleDates.handleDates(x));
  }

  public async findequations(): Promise<EquationDtoResponse> {
    let url = `${this.BASE_URL}lookup/findequations`;
    return this.http.get<EquationDtoResponse>(url).toPromise().then(x => this.handleDates.handleDates(x));
  }

  public async findCapacitySubCategories(): Promise<any> {
    let url = `${this.BASE_URL}CapacitySubCategories?orderby=Description&$select=CapacitySubCategoryId,Description`;
    return await this.http.get<any>(url).toPromise();
  }

  public async findItemScopingCategories(): Promise<any> {
    let url = `${this.BASE_URL}ItemScopingCategories?$select=ItemScopingCategoryId,Description`;
    return await this.http.get<any>(url).toPromise();
  }
}

export interface CostCodeCostTypeDtoResponse {
  Results: Array<ICostCodeCostTypeDto>;
}

export interface ProjectTypeDtoResponse {
  Results: Array<IProjectTypeDto>;
}

export interface FunctionDtoResponse {
  Results: Array<IFunctionDto>;
}

export interface ProjectSubTypeDtoResponse {
  Results: Array<IProjectSubTypeDto>;
}

export interface ConstructionTypeDtoResponse {
  Results: Array<IConstructionTypeDto>;
}

export interface UnitOfMeasureDtoResponse {
  Results: Array<IUnitOfMeasureDto>;
}

export interface ProjectTypePhasesAndStepsDtoResponse {
  Results: Array<IProjectTypePhasesAndStepsDto>;
}

export interface EquationDtoResponse {
  Results: Array<IEquationDto>;
}